import Vue from 'vue'
import Vuex from 'vuex'
import { uiState } from './ui/index'
import { mapState } from './maps/index'
import { authState } from './auth/index'
import { trailState } from './trails/index'
import { subscriptionState } from './subscriptions/index'
import { notificationsState } from './notifications/index'
import { pointsOfInterestState } from './pointsOfInterest/index'
import { GeofencesHelpers, GlobalHelpers } from '@/helpers/mainExports'
import Dexie from 'dexie'

Vue.use(Vuex)
Vue.config.devtools = process.env.NODE_ENV === 'development'

export default new Vuex.Store({
  state: {
    connectionRetryCount: 0,
    indexDB: new Dexie('live-tracking-database'),
    filterSelectedThings: [],
    thingsFromResponse: [],
    totalAmountOfThings: 0,
    filterMustBeApplied: false,
    searchInput: '',
    searchMatch: [],
    toolbarAppBox: false,
    singleExpand: true,
    singleSelect: false,
    expanded: [],
    selected: [],
    map: {
      setMapTypeId: null
    },
    googleMapApi: {},
    markerCluster: null,
    token: localStorage.getItem('ACCESS_TOKEN') || '',
    user: JSON.parse(String(localStorage.getItem('user'))),
    tokenValid: false,
    mainDataTableReference: {},
    showGeofences: false,
    geofences: [],
    filterGeofences: [],
    geofencesOnMap: [],
    matchPosition: 1,
    disconnectDialogValue: false,
    disconnectDialogMessage: '',
    geofenceInLocalStorage: localStorage.getItem('geofenceSelected') ?? [],
    showGeofenceLoadingButton: false,
    thingServices: []
  },
  getters: {
    map: state => state.map,
    mainDataTable: state => state.mainDataTableReference,
    isMarkerClusterCreated: state => !!state.markerCluster,
    toolbarAppBoxState: state => state.toolbarAppBox,
    showGeofence: state => state.showGeofences,
    getGeofences: state => state.geofences,
    getNumberGeofences: state => state.geofences.length,
    getGeofencesOnMap: state => state.geofencesOnMap,
    showGeofencesOnMap: state => state.geofencesOnMap.length > 0,
    getGeofenceInLocalStorage: state => state.geofenceInLocalStorage,
    getSearchMatch: state => state.searchMatch,
    getGeofencesFilter: state => state.filterGeofences,
    setMatchPosition: (state, matchPosition) =>
      (state.matchPosition = matchPosition),
    getSearchInput: state => state.searchInput,
    getMatchPosition: state => state.matchPosition,
    setSearchMatch: (state, payload) => (state.searchMatch = payload),
    getGeofencesSortedByName(state) {
      return state.filterGeofences.sort(
        (geoA: { properties }, geoB: { properties }) =>
          geoA.properties.name > geoB.properties.name
            ? 1
            : geoA.properties.name < geoB.properties.name
            ? -1
            : 0
      )
    },
    getFilterSelectedThings: state => state.filterSelectedThings,
    getThingsFromResponse: state => state.thingsFromResponse,
    getTotalAmountOfThings: state => state.totalAmountOfThings,
    getThingServices: state => state.thingServices
  },
  mutations: {
    setFilterMustBeApplied(state, { filterMustBeApplied }) {
      state.filterMustBeApplied = filterMustBeApplied
    },
    setFilterSelectedThings(state, { selectedThings }) {
      state.filterSelectedThings = selectedThings
    },
    setFilterGeofencesByString(state, { filterGeofences }) {
      state.filterGeofences = filterGeofences
    },
    setDisconnectDialogValue(state, payload) {
      state.disconnectDialogValue = payload
    },
    setDisconnectDialogMessage(state, payload) {
      state.disconnectDialogMessage = payload
    },
    toggleToolbarAppBox: state => (state.toolbarAppBox = !state.toolbarAppBox),
    toggleUserPreferences(state, user) {
      localStorage.setItem('user', JSON.stringify(user))
      state.user = user
    },
    closeToolbarAppBox: state => (state.toolbarAppBox = false),
    expandItem(state, value) {
      state.expanded = value
    },
    setMarkerCluster(state, markerCluster) {
      state.markerCluster = markerCluster
    },
    setMainDataTableReference(state, mainDataTableReference) {
      state.mainDataTableReference = mainDataTableReference
    },
    setGeofenceMap(state, { showGeofencesMap }) {
      state.showGeofences = showGeofencesMap
    },
    setGeofences(state, { zones }) {
      state.geofences = zones
    },
    addGeofencesOnMap(state, { geofenceOnMap }) {
      const geofencesOnMap: any | never = geofenceOnMap
      state.geofencesOnMap.push(geofencesOnMap)
    },
    destroyGeofencesOnMap(state) {
      state.geofencesOnMap = []
    },
    setGeofencesInLocalStorage(state) {
      state.geofenceInLocalStorage =
        JSON.parse(JSON.stringify(localStorage.getItem('geofenceSelected'))) ??
        []
    },
    resetFilterGeofencesState(state) {
      state.filterGeofences = state.geofences
    },
    setMatchPosition(state, matchPosition) {
      state.matchPosition = matchPosition
    },
    setSearchMatch(state, payload) {
      state.searchMatch = payload
    },
    setShowGeofenceLoadingButton(state) {
      state.showGeofenceLoadingButton = !state.showGeofenceLoadingButton
    },
    setThingsFromResponse(state, { thingsFromResponse }) {
      state.thingsFromResponse = thingsFromResponse
    },
    setTotalAmountOfThings(state, { totalAmountOfThings }) {
      state.totalAmountOfThings = totalAmountOfThings
    },
    setThingServices(state, payload) {
      state.thingServices = payload
    }
  },
  actions: {
    filterGeofencesByString({ state, dispatch, commit }, { string }) {
      if (string.length > 1) {
        const filterGeofences = state.geofences.filter((geofence: any) =>
          geofence.properties.name.toLowerCase().match(string)
        )
        commit('setFilterGeofencesByString', { filterGeofences })
      } else commit('resetFilterGeofencesState')
    },
    setSearchMatch({ commit }, payload) {
      commit('setSearchMatch', payload)
    },
    setMatchPosition({ commit }, matchPosition) {
      commit('setMatchPosition', matchPosition)
    },
    setMainDataTableReference({ commit }, mainDataTableReference) {
      commit('setMainDataTableReference', mainDataTableReference)
    },
    toggleUserPreferences({ commit }, payload) {
      //Typescrit genera conflicto esperando string
      const storage = String(localStorage.getItem('user'))

      const user = JSON.parse(storage)

      user[payload.key] = payload.value

      commit('toggleUserPreferences', user)
    },
    toggleToolbarAppBox({ commit }) {
      commit('toggleToolbarAppBox')
    },
    closeToolbarAppBox({ commit }) {
      commit('closeToolbarAppBox')
    },
    setGeofence({ commit }, { zones }) {
      commit('setGeofences', { zones })
    },
    saveGeofenceOnMap({ commit }, { geofenceOnMap }) {
      commit('addGeofencesOnMap', { geofenceOnMap })
    },
    destroyGeofencesOnMap({ commit, getters }) {
      getters.getGeofencesOnMap.map(geofenceOnMap => {
        geofenceOnMap.setMap(null)
      })
      commit('setGeofenceMap', { showGeofencesMap: false })
      commit('destroyGeofencesOnMap')
    },
    async showGeofences({ commit, getters, dispatch }, { map, zonesStorage }) {
      commit('setGeofencesInLocalStorage')
      commit('setShowGeofenceLoadingButton')
      if (!getters.showGeofencesOnMap) {
        const promisesGeofencesSelected: any = []

        const zonesStoragePartition = GlobalHelpers.chunkArray(zonesStorage, 20)

        for (const zonesStorage of zonesStoragePartition) {
          for (const id of zonesStorage) {
            promisesGeofencesSelected.push(GeofencesHelpers.getGeofence(id))
          }

          const results: any = await Promise.allSettled(
            promisesGeofencesSelected
          )
          const zonesSelected = results.map((result: any) => {
            if (result.status === 'fulfilled') {
              const { value } = result
              Object.assign(value.data, { id: value.id })
              if (Boolean(value)) return value.data
              else return {}
            }
          })

          for (const geo of getters.getGeofences) {
            for (const geoSelected of zonesSelected) {
              if (geoSelected.id === geo.id) {
                Object.assign(geo, geoSelected)
              }
            }
          }

          GeofencesHelpers.geofenceOnMap(zonesSelected, map)
        }
      } else {
        dispatch('destroyGeofencesOnMap')
      }
      commit('setShowGeofenceLoadingButton')
    },
    async doAllGeofencesSelected(
      { getters, dispatch },
      { map, setGeofenceSelected }
    ) {
      const geofencesId = getters.getGeofences.map(geofence => geofence.id)
      localStorage.setItem('geofenceSelected', JSON.stringify(geofencesId))
      try {
        const promisesGeofencesPartition: any = []

        const geofencePartition = GlobalHelpers.chunkArray(
          getters.getGeofences,
          20
        )

        for (const geoPart of geofencePartition) {
          for (const geo of geoPart) {
            promisesGeofencesPartition.push(
              GeofencesHelpers.getGeofence(geo.id)
            )
          }

          const results: any = await Promise.allSettled(
            promisesGeofencesPartition
          )

          const geoResults = results.map((result: any) => {
            if (result.status === 'fulfilled') {
              const { value } = result
              Object.assign(value.data, { id: value.id })
              if (Boolean(value)) return value.data
              else return {}
            }
          })

          for (const geofence of getters.getGeofences) {
            for (const geoCord of geoResults) {
              if (geoCord.id === geofence.id) {
                geofence.geometry.coordinates = geoCord.geometry.coordinates
                geofence.hideGeofence = false
              }
            }
          }
        }

        const geofenceSelected = setGeofenceSelected(
          JSON.parse(JSON.stringify(getters.getGeofences))
        )
        dispatch('destroyGeofencesOnMap')

        GeofencesHelpers.geofenceOnMap(geofenceSelected, map)
      } catch (e) {
        console.error(e)
      }
    },
    setThingsFromResponse({ commit }, { thingsFromResponse }) {
      commit('setThingsFromResponse', { thingsFromResponse })
    }
  },
  modules: {
    authState,
    mapState,
    notificationsState,
    subscriptionState,
    trailState,
    uiState,
    pointsOfInterestState
  }
})
